import { IANA_TIMEZONE_CANONICAL_MAP } from "../constants/dateFormat";

export const GetTimeZoneName = () => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return IANA_TIMEZONE_CANONICAL_MAP[timeZone] || timeZone;
}

export const GetTimeZone = () => {
    const date = new Date();
    const timeZone = GetTimeZoneName();
    const offset = date.getTimezoneOffset() / -60;
    const gmtOffset = `GMT${offset >= 0 ? '+' : ''}${offset.toString().padStart(2, '0')}`;
    return `${gmtOffset} (${timeZone})`;
  }
